import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "../http/requestConfig";

export default class CityService {
    
    getAll(sCallBack, eCallBack) {
        exeRequest(ApiRoutes.cityResource, {}, sCallBack, eCallBack)
    }
}